import React, { useEffect } from 'react'
import { useSelector } from 'store/redux.store'
import { useDispatch } from 'react-redux'

import { i18nInit } from 'src/app/i18n'
import Cookies from 'js-cookie'

import { useCheckToken } from 'hooks/use-check-token'
import { Redirect } from 'react-router-dom'
import { useLastRoute } from 'hooks/use-last-route'
import { useTos } from 'hooks/use-tos'
import { useRedirectExternalURL } from 'hooks/use-redirect-external-url'
import { getUser } from 'modules/user'
import { getContext } from 'modules/context'
import { DOMAINS } from 'src/modules/auth/auth.constants'
import { Loader } from 'components/loader'
import { checkAndAddSignupRole, checkToRedirectOnboarding, registerSignup, setData } from './preroutes.utils'
import Routes from './routes.component'
import { APP_ROUTES } from './routes.constants'

const PreRoutes = () => {
  useLastRoute()
  const { isDoingRedirect } = useRedirectExternalURL()
  const dispatch = useDispatch()
  const already = React.useRef<boolean>(false)
  const { user } = useSelector(state => state)
  const { isCheckingToken } = useCheckToken(isDoingRedirect)
  const [, updateState] = React.useState()

  useTos({ isCheckingToken })

  useEffect(setData, [])

  useEffect(() => {
    if (isCheckingToken || user) {
      return
    }

    dispatch(getUser())
  }, [isCheckingToken, user])

  useEffect(() => {
    if (!user || already.current) {
      return
    }

    if (!user.isBuyer) {
      dispatch(getContext())
    }

    i18nInit(user.language ?? 'en')
      .then(() => {
        Cookies.set('hmLangCookie', user.language ?? 'en', {
          domain: process.env.NODE_ENV === 'production' ? DOMAINS.production : DOMAINS.development
        })
        already.current = true
        updateState({} as any)
      })
      .catch(error => console.error('[i18nInit]', error))
      .finally(() => {
        checkAndAddSignupRole({
          authorities: user.profile?.roles?.map(item => item.name),
          userId: user.id
        })
        registerSignup(user)
      })
  }, [user])

  if (already.current && user && !user.isBuyer) {
    if (checkToRedirectOnboarding(user.hasSignupRole)) {
      return <Redirect push to={APP_ROUTES.onboarding} />
    }

    return <Routes />
  }

  return <Loader id="preroutes-loader" />
}

export default React.memo(PreRoutes)
